import { getUser, buildPreferencesPatch } from '../services/UserProfileService.jsx';
import { getEffectivePermissions } from '../services/admin-settings/UserPermissionService.jsx';
import { setUserInformation, setEffectivePermissions, updateDashboardContext } from '../redux-store/ReduxStore.js';

/**
 * Re-fetches the current user's profile + effective permissions and pushes them into Redux —
 * the same load `DashboardLayout` performs on first mount, factored out so it can be re-run
 * on demand (e.g. when an org owner approves a pending access request, so the user sees their
 * new access without re-logging in).
 *
 * @param {{ accessToken: string, dispatch: Function }} args
 * @returns {Promise<Array>} the user's orgs (`[{ orgId, orgState }]`); empty if none / no token.
 */
export const refreshUserDetails = async ({ accessToken, dispatch }) => {
    if (!accessToken) return [];

    const [userData, perms] = await Promise.all([
        getUser({ accessToken }),
        getEffectivePermissions({ accessToken }),
    ]);

    let orgs = [];
    if (userData?.user) {
        orgs = userData.user.orgUserStates
            ? Object.entries(userData.user.orgUserStates).map(([orgId, orgState]) => ({ orgId, orgState }))
            : [];
        dispatch(setUserInformation({
            userId: userData.user.userId || null,
            userName: userData.user.userName || null,
            orgs,
            roleId: userData.user.roleId || null,
            superUser: userData.user.superUser || false,
        }));
        dispatch(updateDashboardContext(buildPreferencesPatch(userData.user)));
    }

    dispatch(setEffectivePermissions(perms));
    return orgs;
};
